import type { FunctionComponent } from 'react';

import { Link, Modal } from '@dr.pogodin/react-utils';

import IconCross from 'assets/images/icon-cross-24px.svg';

import modalTheme from './modal.scss';

import './style.scss';

type PropsT = {
  onClose: () => void;
};

const TocModal: FunctionComponent<PropsT> = ({ onClose }) => (
  <Modal onCancel={onClose} theme={modalTheme}>
    <div styleName="header">
      <h1>Soul Sanctuary Practitioner Terms & Conditions</h1>
      <Link keepScrollPosition onClick={onClose} to="">
        <IconCross />
      </Link>
    </div>
    <div styleName="content">
      <p>
        These Terms & Conditions (“Agreement”) govern the relationship between
        Soul Sanctuary (“Company,” “we,” “our,” or “us”) and each practitioner
        (“Practitioner,” “you,” or “your”) who participates in the Soul
        Sanctuary platform.
      </p>
      <p>
        By submitting content, engaging with the platform, or otherwise agreeing
        to participate, you accept these Terms & Conditions.
      </p>
      <h2>1. Eligibility & Enrollment</h2>
      <ul>
        <li>
          You must be at least 18 years old and legally able to enter into
          contracts.
        </li>
        <li>
          You must provide accurate personal and professional information,
          including certifications, qualifications, or other credentials
          relevant to your practice area(s).
        </li>
        <li>
          Acceptance as a Practitioner is at the sole discretion of Soul
          Sanctuary.
        </li>
      </ul>
      <h2>2. Content Submission</h2>
      <ul>
        <li>
          Practitioners may submit original content (video, audio, written,
          or other formats) in accordance with Soul Sanctuary’s Content
          Guidelines.
        </li>
        <li>
          Content must not infringe on any third-party intellectual property
          rights or include unlawful, defamatory, obscene, or harmful material.
        </li>
        <li>
          By submitting content, you represent and warrant that you are the sole
          creator and owner of the content, or have obtained all necessary
          rights, permissions, and licenses.
        </li>
      </ul>
      <h2>3. License to Soul Sanctuary</h2>
      <ul>
        <li>
          You grant Soul Sanctuary a worldwide, royalty-free, non-exclusive
          license to use, reproduce, distribute, display, modify (for
          formatting, editing, or classification), and promote your content on
          the platform and across associated marketing channels.
        </li>
        <li>
          This license is revocable if you formally withdraw from the program,
          subject to a reasonable wind-down period (e.g., 90 days).
        </li>
      </ul>
      <h2>4. Compensation</h2>
      <ul>
        <li>
          Practitioners may be compensated based on viewership, engagement,
          or revenue-share models as defined by Soul Sanctuary’s compensation
          policies.
        </li>
        <li>
          Specific payout structures will be communicated separately and may be
          updated from time to time with notice.
        </li>
        <li>
          Practitioners are responsible for reporting and paying any applicable
          taxes.
        </li>
      </ul>
      <h2>5. Use of Likeness & Branding</h2>
      <ul>
        <li>
          You consent to Soul Sanctuary’s use of your name, biography, image,
          and likeness for purposes of platform presentation, promotion, and
          marketing.
        </li>
        <li>
          You may identify yourself as a Soul Sanctuary Practitioner, but may
          not misrepresent your role or claim partnership/ownership without
          prior written approval.
        </li>
      </ul>
      <h2>6. Standards of Conduct</h2>
      <ul>
        <li>
          Practitioners must conduct themselves professionally and ethically in
          all interactions with users, the company, and fellow practitioners.
        </li>
        <li>
          Discrimination, harassment, or misconduct of any kind will result in
          immediate suspension or termination.
        </li>
        <li>
          Practitioners must not provide medical advice unless explicitly
          licensed and qualified to do so.
        </li>
      </ul>
      <h2>7. Confidentiality</h2>
      <ul>
        <li>
          You may gain access to non-public information about Soul Sanctuary,
          its users, or its business. You agree to keep this information
          strictly confidential.
        </li>
      </ul>
      <h2>8. Intellectual Property</h2>
      <ul>
        <li>
          Except for the license granted above, you retain ownership of your
          original content.
        </li>
        <li>
          Soul Sanctuary retains all rights to its platform, trademarks, brand
          assets, and proprietary technology.
        </li>
      </ul>
      <h2>9. Term & Termination</h2>
      <ul>
        <li>
          This Agreement remains in effect unless terminated by either party.
        </li>
        <li>Practitioners may withdraw with [30–60 days] written notice.</li>
        <li>
          Soul Sanctuary may terminate this Agreement immediately for breach of
          these Terms, misconduct, or any other reason deemed necessary
          to protect the platform.
        </li>
      </ul>
      <h2>10. Disclaimers</h2>
      <ul>
        <li>
          Soul Sanctuary is not responsible for any injuries, damages, or losses
          resulting from user engagement with practitioner content.
        </li>
        <li>
          Practitioners must clearly communicate any risks, contraindications,
          or limitations associated with their practices.
        </li>
      </ul>
      <h2>11. Indemnification</h2>
      <ul>
        <li>
          You agree to indemnify, defend, and hold harmless Soul Sanctuary,
          its affiliates, and its representatives from any claims, damages,
          or liabilities arising from your content, conduct, or breach of this
          Agreement.
        </li>
      </ul>
      <h2>12. Governing Law & Dispute Resolution</h2>
      <ul>
        <li>
          This Agreement will be governed by the laws of the state of
          California.
        </li>
        <li>
          Any disputes shall be resolved through binding arbitration or
          mediation in California, unless otherwise required by law.
        </li>
      </ul>
      <h2>13. Amendments</h2>
      <ul>
        <li>
          Soul Sanctuary reserves the right to update these Terms at any time.
          Practitioners will be notified of material changes. Continued
          participation constitutes acceptance of updated Terms.
        </li>
      </ul>
      <h2>14. Acknowledgment</h2>
      <p>
        By clicking “I Agree,” signing below, or submitting content to Soul
        Sanctuary, you acknowledge that you have read, understood, and agree
        to these Terms & Conditions.
      </p>
    </div>
  </Modal>
);

export default TocModal;
